const dbName = 'wayke-db';
let db: IDBDatabase | undefined;

export const indexedDbInitialize = async (version = 1) => {
  if (db) return db;

  const _db = await new Promise<IDBDatabase>((resolve, reject) => {
    const openRequest = indexedDB.open(dbName, version);
    openRequest.onerror = () => {
      reject(false);
    };
    openRequest.onsuccess = () => {
      resolve(openRequest.result);
    };
    openRequest.onupgradeneeded = () => {
      if (!openRequest.result.objectStoreNames.contains('assignment')) {
        openRequest.result.createObjectStore('assignment', { autoIncrement: true });
      }
    };
  });
  db = _db;
  return db;
};

export const indexedDbSet = async (store: string, value: any, key: string) => {
  if (!db) throw 'Db not initialized';

  await new Promise((resolve, reject) => {
    const transaction = db!.transaction(store, 'readwrite');

    const userObjectStore = transaction.objectStore(store);

    const request = userObjectStore.put(value, key);

    request.onsuccess = () => {
      resolve(true);
    };

    request.onerror = () => {
      reject(true);
    };
  });
};

export const indexedDbGet = async (store: string, key: string) => {
  if (!db) throw 'Db not initialized';

  const result = await new Promise((resolve, reject) => {
    const transaction = db!.transaction(store, 'readonly');
    const userObjectStore = transaction.objectStore(store);

    const request = userObjectStore.get(key);

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => {
      reject(false);
    };
  });
  return result;
};

export const indexedDbDelete = async (store: string, key: string) => {
  if (!db) throw 'Db not initialized';

  const result = await new Promise((resolve, reject) => {
    const transaction = db!.transaction(store, 'readwrite');
    const userObjectStore = transaction.objectStore(store);

    const request = userObjectStore.delete(key);

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => {
      reject(false);
    };
  });
  return result;
};

export const indexedDbAssignmentSet = async (value: any) => {
  await indexedDbInitialize();
  await indexedDbSet('assignment', value, '1');
};

export const indexedDbAssignmentGet = async () => {
  await indexedDbInitialize();
  return await indexedDbGet('assignment', '1');
};

export const indexedDbAssignmentClear = async () => {
  await indexedDbInitialize();
  return await indexedDbDelete('assignment', '1');
};
